export default __webpack_public_path__ + "static/media/galaxfy-ss.994ff36d.png";